module.exports = __webpack_public_path__ + "img/picture_kydsb.86ca4866.png";